import React from "react";
import { Row, Col, Avatar } from "antd";
import classnames from "classnames";
import styles from "./index.module.less";
import { g4 } from "../../../../utils/helper";
import { CommentOutlined } from "@ant-design/icons";
import { replaceUrlWithAnchor } from "@Lib/common";

class Item extends React.Component {
  io = null;
  constructor(props) {
    super(props);
    this.state = {
      value: "",
    };
    this.value = "";
  }
  respond(re_id, item) {
    //點擊回應
    let value = this.refs[`textarea-${re_id}`].value;
    this.props.replyComment(re_id, value, item);
  }
  componentWillReceiveProps(res) {
    if (this.value != "") {
      let _ref = this.refs[this.value];
      _ref.style.display = "none";
      this.value = "";
    }
  }
  componentDidMount() {
    this.scrollWatch(this.el);
  }
  showReplyComment(id) {
    let _ref = "";
    if (this.value != "") {
      _ref = this.refs[this.value];
      _ref.style.display = "none";
      this.value = "";
    } else {
      this.value = `foot-${id}`;
      _ref = this.refs[this.value];
      _ref.style.display = "block";
    }
  }

  scrollWatch = (el) => {
    let isFrist = false;

    try {
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !isFrist) {
            isFrist = true;
            g4 &&
              g4("element_exposured", {
                page_name: "影音詳情頁",
                element: "列表",
                element_id: "留言列表",
              });
          }
        },
        { threshold: [0.65] },
      );
      if (el) {
        this.io.observe(el);
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { data, type } = this.props;

    return (
      <div className={styles["comment-item"]} ref={(el) => (this.el = el)}>
        <Row>
          <Col span={2}>
            <Avatar
              size={52}
              src={
                (data?.hasOwnProperty("member") ? data?.member.m_headpic_new : data?.user?.cover) ||
                "https://photo.8891.com.tw/2022/10/11/1665473463771127.png"
              }
            />
          </Col>
          <Col span={22}>
            <h4>
              {data?.m_name || data?.user?.name}{" "}
              <span className={styles["time"]}>{data?.add_time || data?.comment.date}</span>
            </h4>
            <div
              className={styles["content"]}
              style={{ marginBottom: type !== "ytb" ? "" : "30px" }}
              dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(data?.content || data?.comment?.content) }}
            ></div>
            <div className={styles["footer"]}>
              {type !== "ytb" && (
                <div
                  className={styles["reply-comment"]}
                  onClick={() => this.showReplyComment(data?.id || data?.comment?.id)}
                >
                  <CommentOutlined style={{ fontSize: "16px" }} className='mr-6' />
                  回應
                </div>
              )}
              <div
                className={classnames(styles["reply-foot"], styles["reply-comment-none"])}
                ref={`foot-${data?.id || data?.comment.id}`}
              >
                <textarea
                  ref={`textarea-${data?.id || data?.comment?.id}`}
                  className={styles["textarea"]}
                  placeholder={`回覆${data?.m_name || data?.user?.name}:`}
                />
                <div className={styles["reply-btn"]} onClick={() => this.respond(data?.id || data?.comment?.id, data)}>
                  回應評論
                </div>
              </div>
            </div>
            {data?.hasOwnProperty("comment") && JSON.stringify(data?.comment?.reply) !== "{}" && (
              <div className={styles["reply-list"]}>
                {/* {data?.reply.map((v, i) => ( */}
                <div className={styles["reply-item"]}>
                  <h5 className={styles["reply-name"]}>
                    {data?.comment.reply.user.name}
                    {/* <span className={styles["time"]}>{`回覆於 ${v.add_time}`}</span> */}
                  </h5>
                  <div
                    className={styles["reply-conent"]}
                    dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(data?.comment?.reply?.comment?.content ?? "") }}
                  ></div>
                </div>
                {/* ))} */}
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default Item;
